export const formatCurrency = (value) => {
  if (value == null) return ""; // Maneja null o undefined
  const numericValue = String(value).replace(/\D/g, ""); // Convierte a string y limpia caracteres no numéricos
  return new Intl.NumberFormat("es-CO").format(Number(numericValue)); // Asegura que sea número antes de formatear
};
